import axios from "axios";
import { errorHandler } from "../exports/error_management";

const api = async (method, path, params) => axios[method](path, params);

const state = {
  report_template: {},
  keys: {},
  report_templates: [],
};

const getters = {
  emailTemplates(state) {
    return state.report_templates.filter(
      (x) => x.recipe == "html" && x.engine == "handlebars").map(({ id, name, description }) => ({ id, title: `${name}${description ? ('-' + description) : ''}` }));
  },
};

const mutations = {
  set_report_template(state, payload) {
    state.report_template = payload;
  },
  set_report_templates(state, payload) {
    state.report_templates = payload;
  },
  set_keys(state, payload) {
    state.keys = payload;
  },
};

const actions = {
  async create(context, payload) {
    try {
      console.log("create:  payload", payload);
      const results = await api("post", `report-template`, payload);
      context.commit("set_report_template", results.data.success.data);
    } catch (err) {
      console.error("create:  payload", err);
      errorHandler(err);
    }
  },
  async fetchById(context, id) {
    try {
      const results = await api("get", `report-template/${id}`);
      context.commit("set_report_template", results.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchAll(context) {
    try {
      const results = await api("get", `report-template`);
      console.log("results.data", results.data);
      const data = results.data.success.data;

      context.commit("set_report_templates", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchOrderKeys(context) {
    try {
      const results = await api("get", `report-template/order-keys`);
      console.log("results.data", results.data);
      const data = results.data.success.data;
      console.log("store keys:", data);
      context.commit("set_keys", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async update(context, payload) {
    console.log("update:", payload);
    try {
      const results = await api(
        "put",
        `report-template/${payload.id}`,
        payload
      );
      context.commit("set_report_template", results.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },
  async delete(context, id) {
    try {
      await api("delete", `report-template/${id}`);
      context.commit("set_report_templates", null);
      // context.dispatch('fetchAll')
    } catch (err) {
      errorHandler(err);
    }
  },
};



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
